import { Injectable, Injector } from '@angular/core';
import * as coreModels from 'libs/dc-core/models/base.models';
import { Observable } from 'rxjs';
import { DenWriterApi } from '../../base-apis/base-api'
import * as models from '../models/auto-generated-models';


@Injectable()
export class AppDomainWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'appDomain');
         }
        createSubdomain(obj: models.CreateSubdomainDEN , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.CreateSubdomainResponse>{
       return this.getByCustomFilterWithUrl<models.CreateSubdomainResponse>(obj, "createSubdomain",_dependencies);
    };
               
 	 	deleteSubdomain(obj: models.CreateSubdomainDEN , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.CreateSubdomainResponse>{
       return this.getByCustomFilterWithUrl<models.CreateSubdomainResponse>(obj, "deleteSubdomain",_dependencies);
    };
               
}
 
@Injectable()
export class CustomerMicroServiceWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'customerMicroServices');
         }
        resizeMS(obj: models.ResizeMSUICmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "resize",_dependencies);
    };
               
 	 	installMS(obj: models.InstallMicroServiceUICommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "install",_dependencies);
    };
               
 	 	deleteMS(obj: models.DeleteMSUICmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "delete",_dependencies);
    };
               
 	 	updateMS(obj: models.UpdateMSUICmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "update",_dependencies);
    };
               
}
 
@Injectable()
export class CustomerProfileWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'customerProfile');
         }
        loginUsingPasscode(obj: models.PassCodeAccessRequest , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.PassCodeAccessResponse>{
       return this.getByCustomFilterWithUrl<models.PassCodeAccessResponse>(obj, "loginUsingPasscode",_dependencies);
    };
               
 	 	saveClientImageRegistry(obj: models.ClientImageRegistrationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "clientImageRegistry/save",_dependencies);
    };
               
 	 	deleteClientImageRegistry(registryName: string):Observable<coreModels.StatusContainer>  {
       return this.remove<coreModels.StatusContainer>("clientImageRegistry/"+registryName);
    };
             
 	 	captureAwsCloudConfiguration(obj: models.CaptureAwsCloudConfigurationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "cloudConfiguration/aws",_dependencies);
    };
               
 	 	captureAzureCloudConfiguration(obj: models.CaptureAzureCloudConfigurationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "cloudConfiguration/azure",_dependencies);
    };
               
 	 	captureDockerConfiguration(obj: models.CaptureDockerConfigurationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "cloudConfiguration/dockerConfiguration",_dependencies);
    };
               
 	 	captureGoogleCloudConfiguration(obj: models.CaptureGoogleCloudConfigurationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "cloudConfiguration/google",_dependencies);
    };
               
 	 	captureOnPremCloudConfiguration(obj: models.CaptureOnPremCloudConfigurationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "cloudConfiguration/onPrem",_dependencies);
    };
               
 	 	updateAwsCloudConfiguration(obj: models.UpdateAwsCloudConfigurationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "updateCloudConfiguration/aws",_dependencies);
    };
               
 	 	updateAzureCloudConfiguration(obj: models.UpdateAzureCloudConfigurationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "updateCloudConfiguration/azure",_dependencies);
    };
               
 	 	updateGoogleCloudConfiguration(obj: models.UpdateGoogleCloudConfigurationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "updateCloudConfiguration/google",_dependencies);
    };
               
 	 	updateOnPremCloudConfiguration(obj: models.UpdateOnPremCloudConfigurationCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "updateCloudConfiguration/onPrem",_dependencies);
    };
               
 	 	cleanUp():Observable<coreModels.StatusContainer>  {
       return this.remove<coreModels.StatusContainer>("cleanUp");
    };
             
}
 
@Injectable()
export class DenDeploymentWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'DEN');
         }
        upgrade(obj: models.UpgradeDeploymentUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "updateDeployment",_dependencies);
    };
               
 	 	resizingResources(obj: models.ResizeDeploymentCommandUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "resizingResources",_dependencies);
    };
               
 	 	deleteAndAddNewDeployment(obj: models.ResizeDeploymentCommandUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "addDeployment",_dependencies);
    };
               
 	 	restartDeployment(obj: models.RestartDeploymentUICmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "restart",_dependencies);
    };
               
 	 	updateConfigMap(obj: models.UpdateConfigMapUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "updateConfigMap",_dependencies);
    };
               
}
 
@Injectable()
export class InfraManagementWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'infra');
         }
        setupDevumInfra(obj: models.FECreateDevumInfraCommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "setupInfra/devum",_dependencies);
    };
               
 	 	addEnvironment(obj: models.FENamespaceCreateCommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "addEnvironment",_dependencies);
    };
               
}
 
@Injectable()
export class InstallationLogApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, '');
         }
        
}
 
@Injectable()
export class MiniCrmWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'miniCrm');
         }
        createMarketUser(obj: models.ApproveSignupRequestCommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.UserPoolPrecis>{
       return this.getByCustomFilterWithUrl<models.UserPoolPrecis>(obj, "createMarketPlaceUser",_dependencies);
    };
               
 	 	rejectUser(obj: models.RejectUserPayload , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.CountContainer>{
       return this.getByCustomFilterWithUrl<coreModels.CountContainer>(obj, "rejectUser",_dependencies);
    };
               
 	 	deleteUserAndResources(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<coreModels.StatusContainer>>  {
       return this.remove<coreModels.StatusContainer>("deleteUserAndResources");
    };
             
 	 	createSubscription(obj: models.CreateCustomSubscriptionCommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.Organization>{
       return this.getByCustomFilterWithUrl<models.Organization>(obj, "createSubscription",_dependencies);
    };
               
 	 	approveUser(obj: models.ApproveSignupRequestCommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.UserStatus>{
       return this.getByCustomFilterWithUrl<models.UserStatus>(obj, "approveUser",_dependencies);
    };
               
 	 	createAppMapping(obj: models.CreateAppMappingCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "appMapping",_dependencies);
    };
               
}
 
@Injectable()
export class OrgImageMappingWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'orgImageMapping');
         }
        
}
 
@Injectable()
export class PaymentGatewayWebHookApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, '');
         }
        
}
 
@Injectable()
export class PreLoginWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, '');
         }
        handlerForgotAlias(obj: models.ForgotAliasPayload , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.ForgotAliasResponse>{
       return this.getByCustomFilterWithUrl<models.ForgotAliasResponse>(obj, "forgotAlias",_dependencies);
    };
               
}
 
@Injectable()
export class RegionEKSClusterWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'clusters');
         }
        insert(obj: models.RegionEKSCluster , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.CreateRegionEKSClusterReferenceCommand>{
       return this.getByCustomFilterWithUrl<models.CreateRegionEKSClusterReferenceCommand>(obj, "insert",_dependencies);
    };
               
}
 
@Injectable()
export class RetryCommandsWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'retryCommandWriter');
         }
        customerProfileRetryCommand(obj: models.RetryCommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "customerProfileRetryCommand",_dependencies);
    };
               
 	 	denDeploymentManagerRetryCommand(obj: models.RetryWithNamespaceCommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "denDeploymentManagerRetryCommand",_dependencies);
    };
               
}
 
@Injectable()
export class SharedDeploymentWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'deployments');
         }
        updateDeployment(obj: models.UpgradeDeploymentUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "updateDeployment",_dependencies);
    };
               
 	 	resizingResources(obj: models.ResizeDeploymentCommandUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "resizingResources",_dependencies);
    };
               
 	 	createNamespace(obj: models.FENamespaceCreateCommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "createEnvironment",_dependencies);
    };
               
}
 
@Injectable()
export class SharedMicroServiceWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'sharedMicroServices');
         }
        restart(obj: models.RestartMSUICmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "restart",_dependencies);
    };
               
 	 	retry(obj: models.RetryWithNamespaceCommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "retry",_dependencies);
    };
               
 	 	resizeMS(obj: models.ResizeMSUICmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "resize",_dependencies);
    };
               
 	 	installMS(obj: models.InstallMicroServiceUICommand , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "install",_dependencies);
    };
               
 	 	deleteMS(obj: models.DeleteMSUICmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "delete",_dependencies);
    };
               
 	 	updateMS(obj: models.UpdateMSUICmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "update",_dependencies);
    };
               
}
 
@Injectable()
export class SignUpRequestWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'signUpRequest');
         }
        signUp(obj: models.SignUpRequest , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.SignUpRequest>{
       return this.getByCustomFilterWithUrl<models.SignUpRequest>(obj, "insert",_dependencies);
    };
               
 	 	verifyOrgCodeAvailability(obj: models.ValidateOrgCodePayload , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.ValidateOrgCodeResponse>{
       return this.getByCustomFilterWithUrl<models.ValidateOrgCodeResponse>(obj, "verifyOrgCodeAvailability",_dependencies);
    };
               
}
 
@Injectable()
export class SubscriptionWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'subscriptions');
         }
        handleAddAddons(obj: models.AddOnCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "addAddons",_dependencies);
    };
               
 	 	handleCreateSubscription(obj: models.PaymentGatewaySubscriptionCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "planSubscription",_dependencies);
    };
               
 	 	handleMigrationPlan(obj: models.MigrationPlanCmdUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "migrationPlan",_dependencies);
    };
               
 	 	handleUpdateSubscriptionStatus(obj: models.UpdateSubscriptionStatusCmdUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "updateSubscriptionStatus",_dependencies);
    };
               
}
 
@Injectable()
export class SupportedRegionWriterApi extends DenWriterApi {

        constructor(injector: Injector) {
            super(injector, 'regions');
         }
        insertNewRegion(obj: models.SupportedRegionUIPayload , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.SupportedRegion>{
       return this.getByCustomFilterWithUrl<models.SupportedRegion>(obj, "insert",_dependencies);
    };
               
 	 	updateConfigurations(entity: models.RegionConfigurations , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.update<coreModels.StatusContainer>(entity, "configurations");
    };
             
}
